<template>
  <div class="flex items-center">

    <span>{{score}}</span>
    <!-- <vs-avatar :src="params.data.avatar" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" />
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary">{{ params.value }}</router-link> -->
  </div>
</template>

<script>
  export default {
      name: 'InsightTestScore',
      data() {
        return {
          url: '',
          score:''
        }
      },
      computed: {
        activeWorkspace() {
          return this.$store.state.space.ActiveSpaceInfo
        }
      },
      created(){
        this.score = this.params.value
      }
  }
</script>
